export function createQuery(host, type, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m"){
    if (type === 'snmp'){
        return `
from(bucket: "telegraf")
  |> range(start: ${durationStart}, stop: ${durationEnd})
  |> filter(fn: (r) => r["_measurement"] == "cpu_system_stats")
  |> filter(fn: (r) => r["_field"] == "cpu_idle" or r["_field"] == "cpu_interrupt" or r["_field"] == "cpu_system" or r["_field"] == "cpu_user")
  |> filter(fn: (r) => r["agent_host"] == "${host}")
  |> aggregateWindow(every: ${durationInterval}, fn: last, createEmpty: true)
  |> yield(name: "mean")
        `;
    }
    else{
        return `
from(bucket: "telegraf")
  |> range(start: ${durationStart}, stop: ${durationEnd})
  |> filter(fn: (r) => r["_measurement"] == "ezelink_cpu_value")
  |> filter(fn: (r) => r["host"] == "${host}")
  |> filter(fn: (r) => r["type_instance"] == "idle" or r["type_instance"] == "interrupt" or r["type_instance"] == "user" or r["type_instance"] == "system")
  |> filter(fn: (r) => r["_field"] == "value")
  |> aggregateWindow(every: ${durationInterval}, fn: last, createEmpty: true)
  |> yield(name: "mean")
        `;
    }
}